import { render, staticRenderFns } from "./AddToItineraryModalBody.vue?vue&type=template&id=36849be1&scoped=true&"
import script from "./AddToItineraryModalBody.vue?vue&type=script&lang=ts&"
export * from "./AddToItineraryModalBody.vue?vue&type=script&lang=ts&"
import style0 from "./AddToItineraryModalBody.vue?vue&type=style&index=0&id=36849be1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36849be1",
  null
  
)

export default component.exports